import { browseMusicRoute } from '@/utils/catalogue.js'

// Full-page Create account and Log in, replacing TheSignupModal and
// TheLoginModal while the switch is on.
export const AUTH_PAGES_SWITCH = 'clean_signup_login_pages'

export const AUTH_PAGE_ROUTES = ['create-account', 'login']

// Only same-site paths, so ?next= can't send anyone to another domain.
export function safeNext (next) {
  if (typeof next !== 'string' || !next.startsWith('/') || next.startsWith('//')) {
    return null
  }
  return next
}

// Where to go after signing up or logging in when there's nowhere to return to.
export function defaultDestination () {
  return browseMusicRoute()
}

// Opens an auth page in place of its modal, remembering where the user was
// (or was headed) so they can be sent back there afterwards.
export function goToAuthPage (router, routeName, redirectTo) {
  const current = router.currentRoute
  let next = safeNext(redirectTo)
  if (!next && current && !AUTH_PAGE_ROUTES.includes(current.name)) {
    next = safeNext(current.fullPath)
  }
  if (next === '/') {
    next = null
  }
  const location = { name: routeName }
  if (next) {
    location.query = { next }
  }
  // Already on the page: pushing again would only raise NavigationDuplicated.
  return router.push(location).catch(() => {})
}

export function passwordRules (password) {
  return [
    { key: 'length', ok: password.length >= 8, text: 'At least 8 characters' },
    { key: 'numeric', ok: password.length > 0 && !/^\d+$/.test(password), text: 'Not only numbers' }
  ]
}
